import { render, staticRenderFns } from "./QuestionBase.vue?vue&type=template&id=bf8d3cd0&scoped=true&"
import script from "./QuestionBase.vue?vue&type=script&lang=js&"
export * from "./QuestionBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8d3cd0",
  null
  
)

export default component.exports